import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'

interface TypingAnimationProps {
  onFinish?: () => void
  text: string
}

const SPEED = 5

const TypingAnimation: React.FC<TypingAnimationProps> = ({ onFinish, text }) => {
  const [index, setIndex] = useState<number>(0)

  useEffect(() => {
    let isCancelled = false
    setIndex(0)

    const typeNextChar = () => {
      if (isCancelled) return

      setIndex((prev) => {
        const next = prev + 1

        if (next < text.length) {
          setTimeout(typeNextChar, SPEED)
        } else {
          onFinish?.()
        }

        return next
      })
    }

    typeNextChar()

    return () => {
      isCancelled = true
    }
  }, [text])

  return (
    // @ts-ignore
    <motion.span
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      style={{ whiteSpace: 'pre-wrap' }}
      transition={{ duration: 0.5 }}
    >
      {text.slice(0, index)}
    </motion.span>
  )
}

export default TypingAnimation
